module.exports = __webpack_public_path__ + "img/youtube.8f8bc228.png";